module.exports = __webpack_public_path__ + "img/background29.d85171b9.jpg";